import { render, staticRenderFns } from "./team_detail.vue?vue&type=template&id=5db8869a&scoped=true&"
import script from "./team_detail.vue?vue&type=script&lang=js&"
export * from "./team_detail.vue?vue&type=script&lang=js&"
import style0 from "./team_detail.vue?vue&type=style&index=0&id=5db8869a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8869a",
  null
  
)

export default component.exports